import classNames from 'classnames';
import React from 'react';
import { v4 as uuid } from 'uuid';
import { StyledFieldInfo, StyledTextField } from './TextField.styles';
export const TextField = React.forwardRef(function (props, ref) {
    // ensures unique value to associate label with input
    const fieldId = uuid();
    const { autoComplete, autoFocus, className, defaultValue, disabled, displayErrors, id, inputProps, label, maxLength, name, onBlur, onChange, onKeyUp, onClick, onFocus, placeholder, promptProps, required, type = 'text', validationErrors, value, readOnly, } = props;
    const handleKeyUp = (e) => {
        if (!onKeyUp && e.key === 'Enter') {
            e.currentTarget.blur();
        }
        onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
    };
    const errorClass = displayErrors ? 'error' : 'prompt';
    return (React.createElement(StyledTextField, { className: className, "data-cy": props['data-cy'], id: id },
        React.createElement("input", Object.assign({ autoComplete: autoComplete, autoFocus: autoFocus, className: classNames('text-input__input-element', {
                filled: (value && value.length > 0) || defaultValue,
            }), disabled: disabled, defaultValue: defaultValue, id: fieldId, maxLength: maxLength, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyUp: handleKeyUp, placeholder: placeholder, required: required, type: type, value: value, readOnly: readOnly, ref: ref }, inputProps)),
        label ? React.createElement("label", { htmlFor: fieldId }, label) : null,
        (validationErrors || maxLength) && (React.createElement(StyledFieldInfo, null,
            validationErrors && (React.createElement("div", null, validationErrors.map((err, i) => {
                return (React.createElement("p", Object.assign({ className: errorClass, key: i }, promptProps), err));
            }))),
            maxLength && (React.createElement("div", { className: classNames('count', { isMax: (value === null || value === void 0 ? void 0 : value.length) === maxLength }) },
                (value === null || value === void 0 ? void 0 : value.length) || 0,
                " / ",
                maxLength))))));
});
//# sourceMappingURL=TextField.js.map